import { Store } from 'reducers/rootReducer';

export type State = {
  publicBrowseOpportunitiesSignUp: boolean;
  publicBrowseOpportunitiesSignIn: boolean;
};

const initialState: State = {
  publicBrowseOpportunitiesSignUp: false,
  publicBrowseOpportunitiesSignIn: false,
};

// Actions
const SET_PUBLIC_BROWSE_OPPORTUNITIES_SIGN_UP =
  'app/browseOpportunities/SET_PUBLIC_BROWSE_OPPORTUNITIES_SIGN_UP';
const SET_PUBLIC_BROWSE_OPPORTUNITIES_SIGN_IN =
  'app/browseOpportunities/SET_PUBLIC_BROWSE_OPPORTUNITIES_SIGN_IN';

// Reducer
type Action =
  | {
      type: typeof SET_PUBLIC_BROWSE_OPPORTUNITIES_SIGN_UP;
      payload: boolean;
    }
  | {
      type: typeof SET_PUBLIC_BROWSE_OPPORTUNITIES_SIGN_IN;
      payload: boolean;
    };

export default function reducer(state = initialState, action: Action): State {
  switch (action.type) {
    case SET_PUBLIC_BROWSE_OPPORTUNITIES_SIGN_UP:
      return {
        ...state,
        publicBrowseOpportunitiesSignUp: action.payload,
      };
    case SET_PUBLIC_BROWSE_OPPORTUNITIES_SIGN_IN:
      return {
        ...state,
        publicBrowseOpportunitiesSignIn: action.payload,
      };
    default:
      return state;
  }
}

// Action creators
export const setPublicBrowseOpportunitiesSignUp = (payload: boolean) => ({
  type: SET_PUBLIC_BROWSE_OPPORTUNITIES_SIGN_UP,
  payload,
});

export const setPublicBrowseOpportunitiesSignIn = (payload: boolean) => ({
  type: SET_PUBLIC_BROWSE_OPPORTUNITIES_SIGN_IN,
  payload,
});

// Selectors
export const selectPublicBrowseOpportunitiesSignUp = (app: Store) =>
  app.browseOpportunities.publicBrowseOpportunitiesSignUp;

export const selectPublicBrowseOpportunitiesSignIn = (app: Store) =>
  app.browseOpportunities.publicBrowseOpportunitiesSignIn;
